import { ReactComponent as ReceiveIcon } from '@basqet-dashboard/common/assets/icons/receive-arrow.svg';
import { ReactComponent as SendIcon } from '@basqet-dashboard/common/assets/icons/send-arrow.svg';
import { TableWrapper } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React from 'react';

import { useFetchPayouts } from '../../../hooks/queries';
import { NoPayouts } from './no-payouts';

const PayoutsHistoryTable = ({ title, link }) => {
  const {
    searchQuery,
    setSearchQuery,
    payouts,
    isFetchingNextPage,
    isRefetching,
    setStatus,
    isLoading,
    hasNextPage,
    fetchNextPage,
    filterByDate
  } = useFetchPayouts();
  let showIsFetching = (!payouts.length && isLoading) || isRefetching || isFetchingNextPage;

  const formattedPayouts = payouts.map((payout) => {
    const { currency, type } = payout;
    const { slug: currencySlug } = currency;
    const amount_currency = `${payout.amount} ${currencySlug}`;
    const TypeIcon = payoutType[type.toLowerCase()];
    return {
      ...payout,
      amount_currency,
      type: <TypeIcon />
    };
  });

  return (
    <section className="payout__history__table">
      <TableWrapper
        data={formattedPayouts}
        title={title}
        name="payout"
        hasFilters
        exportData
        exportUrl={'/payout'}
        link={link}
        isFetching={showIsFetching}
        onLoadMore={() => !link && fetchNextPage()}
        canLoadMore={!link && hasNextPage}
        isLoading={isFetchingNextPage}
        onSearch={setSearchQuery}
        onStatusChange={setStatus}
        onDateFilter={filterByDate}
        emptyDataComponent={<NoPayouts searchTerm={searchQuery} />}
        searchPlaceholder="Search for wallet address or reference ID"
      />
    </section>
  );
};

PayoutsHistoryTable.defaultProps = {
  title: 'All'
};
PayoutsHistoryTable.propTypes = {
  title: PropTypes.string,
  link: PropTypes.object
};

const payoutType = {
  send: SendIcon,
  receive: ReceiveIcon
};
export { PayoutsHistoryTable };
